module.exports = __webpack_public_path__ + "static/media/justMe.995f2f3c.svg";